<template>
  <router-link :to="url" :class="`elr-button ${classes}`"><slot /></router-link>
</template>

<script>
export default {
  name: 'ButtonLink',
  props: {
    url: {
      type: String,
      required: true
    },
    classes: {
      type: String,
      default: 'elr-button-primary'
    }
  }
}
</script>

<style lang="scss" scoped>
.elr-button {
  font-size: 14px;
}
</style>

